export default "__VITE_ASSET__vOaPl5qL__"